export const isValidEmail = (email: string) => {
  if (!email || email.length > 254) {
    return false;
  }

  // RFC 5322-Compliant Regex for email
  const emailRegRule =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return emailRegRule.test(email);
};
